import "core-js/modules/es.array.join.js";
import React from 'react';
import { Flex, Text } from '@applyboard/crystal-ui';
import { SectionTitle } from "./SectionTitle";
import { consts } from "../utils";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
export var EligibleNationalitiesSection = function EligibleNationalitiesSection(_ref) {
  var eligibleNationalities = _ref.eligibleNationalities;
  var eligibleNationalitiesString = eligibleNationalities === null || eligibleNationalities === void 0 ? void 0 : eligibleNationalities.join(', ');
  return _jsxs(Flex, {
    direction: "column",
    gap: 1,
    children: [_jsx(SectionTitle, {
      title: "Eligible nationalities"
    }), _jsx(Text, {
      lineClamp: 2,
      children: eligibleNationalitiesString || consts.allNationalitiesEligible
    })]
  });
};